import { Link } from "react-router-dom";
import logo from "../assets/logo.svg";
import { useState } from "react";
const Navbar = ({ navClasses }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDropdownActive, setIsDropdownActive] = useState(false);

  const handleMobile = () => {
    setIsMobile(!isMobile);
  };

  const closeMobileMenu = () => {
    setIsMobile(false);
    setIsDropdownActive(false);
  };

  const toggleDropdown = () => {
    setIsDropdownActive(!isDropdownActive);
  };

  return (
    <header id="header" className={navClasses}>
      <div className="container">
        <div className="header-container d-flex align-items-center justify-content-between shadow">
          <div className="logo">
            <Link to="/" onClick={closeMobileMenu}>
              <img src={logo} alt="Vergado" className="img-fluid" />
            </Link>
          </div>

          <nav
            id="navbar"
            className={`navbar ${isMobile ? "navbar-mobile" : ""}`}
          >
            <ul>
              <li>
                <Link
                  className="nav-link"
                  to="why-vergado"
                  onClick={closeMobileMenu}
                >
                  Why Vergado
                </Link>
              </li>
              <li className="dropdown">
                <Link to="#" onClick={toggleDropdown}>
                  <span>Products</span>
                  <i className="bi bi-chevron-down"></i>
                </Link>
                <ul className={isDropdownActive ? "dropdown-active" : ""}>
                  <li>
                    <Link to="products/recruitment" onClick={closeMobileMenu}>
                      Recruitment
                    </Link>
                  </li>
                  <li>
                    <Link to="products/onboarding" onClick={closeMobileMenu}>
                      Onboarding & Verifications
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="products/induction-training"
                      onClick={closeMobileMenu}
                    >
                      Induction Training
                    </Link>
                  </li>
                  <li>
                    <Link to="products/attendance" onClick={closeMobileMenu}>
                      Attendance
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="products/leave-management"
                      onClick={closeMobileMenu}
                    >
                      Leave Management
                    </Link>
                  </li>
                  <li>
                    <Link to="products/payroll" onClick={closeMobileMenu}>
                      Payroll{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="products/compliance" onClick={closeMobileMenu}>
                      Compliance Filings & Payments
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="products/expense-management"
                      onClick={closeMobileMenu}
                    >
                      Expense Management
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="products/vendor-management"
                      onClick={closeMobileMenu}
                    >
                      Vendor Management
                    </Link>
                  </li>
                  <li>
                    <Link to="products/cash/advance" onClick={closeMobileMenu}>
                      Advances
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="products/asset-management"
                      onClick={closeMobileMenu}
                    >
                      Asset Management
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="products/document-builder"
                      onClick={closeMobileMenu}
                    >
                      Document Builder
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="products/employee-benefits"
                      onClick={closeMobileMenu}
                    >
                      Employee Benefits
                    </Link>
                  </li>
                  <li>
                    <Link to="products/cash/petty" onClick={closeMobileMenu}>
                      Petty Cash
                    </Link>
                  </li>
                  <li>
                    <Link to="products" onClick={closeMobileMenu}>
                      <strong>View all products</strong>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  className="nav-link"
                  to="resource"
                  onClick={closeMobileMenu}
                >
                  Resources
                </Link>
              </li>
              <li>
                <Link
                  className="nav-link"
                  to="contact-us"
                  onClick={closeMobileMenu}
                >
                  Get Vergado
                </Link>
              </li>
            </ul>
            <i
              className={`bi mobile-nav-toggle ${
                isMobile ? "bi-x" : "bi-list"
              }`}
              onClick={handleMobile}
            ></i>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
